























import {Component} from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';

@Component({components: {}})
export default class AnalysisInfo extends Slide {
  get date() {return this.data.Texts[`analysis_info_date`]; }
  get name() {return this.data.Texts[`analysis_info_name`]; }
  get mail() {return this.data.Texts[`analysis_info_mail`]; }
  get phone() {return this.data.Texts[`analysis_info_phone`]; }
  get contacts() {
    const contacts = this.data.Texts[`analysis_info_contacts`];
    if (!contacts) {
      return [];
    }
    return this.data.Texts[`analysis_info_contacts`].split(';');
  }
}
